import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { usePostDetails } from 'api';
import { GoBackButtonWithTitle, Spinner } from 'components';
import { PageSubTitle, SubTitleAccesnt, TitleW } from 'features/post/components/PageHeader/styled';
import { useCreateDraft } from 'hooks';

import { CreateDocumentForm } from '../../../documents/components';
import { PageHeader } from '../../components';
import { ContentW, PageHeaderW, PageW } from './styled';

export function CreatePostPage(): ReactElement {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isWeOrActions =
    location.pathname.includes('we/add-post') || location.pathname.includes('actions');

  const { draft, isLoading } = useCreateDraft(!params?.documentId);
  const { post, isLoading: isDocumentLoading } = usePostDetails({
    postId: params?.documentId || '',
    queryName: 'document-details',
  });

  const isEdit = !!post;
  const sectionLabel = location.pathname.includes('profile')
    ? t('sidebar.me')
    : location.pathname.includes('employees')
    ? t('breadcrumbs.employee')
    : t('sidebar.actions');

  if (isLoading || isDocumentLoading) {
    return <Spinner />;
  }

  return (
    <PageW>
      <>
        <PageHeaderW>
          <GoBackButtonWithTitle
            title={t('common.back')}
            onClick={() => navigate(-1)}
            containerSx={{
              marginTop: 0,
              maxWidth: '100%',
            }}
          />
        </PageHeaderW>
        <TitleW>
          {isEdit ? (
            <PageSubTitle style={{ marginBottom: '16px' }}>
              {t('document.create.editTitle')}
            </PageSubTitle>
          ) : (
            <>
              <PageSubTitle>
                {sectionLabel} / {t('actions.manager.labels.post')}{' '}
                <SubTitleAccesnt>/ {t('post.create.subTitle')}</SubTitleAccesnt>
              </PageSubTitle>
              <PageHeader pageTitle={t('post.create.title')} />
            </>
          )}
        </TitleW>
      </>
      <ContentW>
        {(draft || post) && (
          <CreateDocumentForm
            draft={draft ? draft : undefined}
            type={isWeOrActions ? 'post' : params?.tag ? 'category' : 'profile'}
            category={params?.tag}
            isEdit={isEdit}
            document={post ? post : undefined}
          />
        )}
      </ContentW>
    </PageW>
  );
}
